module.exports = __webpack_public_path__ + "static/media/carro_1.c8a81609.png";